(() => {
  function initialize(root) {
    if (root.dataset.armReady) return;
    const choice = root.querySelector('#arm-colour-select');
    const main = root.querySelector('#arm-colour-main');
    const thumbs = Array.from(root.querySelectorAll('.arm-colour-thumb'));
    const variantData = root.querySelector('[data-arm-variants]');
    const form = root.querySelector('#ARMTrio6ProductForm');
    if (!choice || !main || !variantData || !thumbs.length) return;
    const variants = JSON.parse(variantData.textContent);
    const price = root.querySelector('[data-arm-price]');
    const sku = root.querySelector('[data-arm-sku]');
    const add = root.querySelector('[data-arm-add]');
    let angle = new URL(location.href).searchParams.get('arm_angle') || '01';
    let current;
    function writeURL() {
      const url = new URL(location.href);
      url.searchParams.set('variant', current.id);
      url.searchParams.set('arm_angle', angle);
      history.replaceState(history.state, '', url);
    }
    function show(button) {
      if (!button) return;
      main.src = button.dataset.full;
      main.alt = button.dataset.alt;
      angle = button.dataset.angle;
      thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
    }
    function change(id, updateURL = true) {
      current = variants.find(variant => variant.id === String(id)) || variants[0];
      choice.value = current.id;
      thumbs.forEach(thumb => { thumb.hidden = thumb.dataset.colour !== current.colour; });
      const eligible = thumbs.filter(thumb => thumb.dataset.colour === current.colour);
      show(eligible.find(thumb => thumb.dataset.angle === angle) || eligible[0]);
      if (form) form.elements.namedItem('id').value = current.id;
      price.textContent = current.price;
      sku.textContent = current.sku;
      if (add) add.disabled = !current.available;
      const availability = root.querySelector('[data-arm-availability]');
      if (add) add.textContent = !current.available ? add.dataset.unavailableLabel : current.stockState !== 'stock' && availability ? availability.dataset.orderButton : add.dataset.availableLabel;
      if (updateURL) writeURL();
    }
    thumbs.forEach(thumb => thumb.addEventListener('click', () => {
      if (thumb.hidden) return;
      show(thumb);
      writeURL();
    }));
    choice.addEventListener('change', () => change(choice.value));
    window.addEventListener('popstate', () => {
      if (!root.isConnected) return;
      const params = new URL(location.href).searchParams;
      angle = params.get('arm_angle') || '01';
      change(params.get('variant') || variants[0].id, false);
    });
    root.dataset.armReady = 'true';
    change(choice.value, false);
  }
  function mount() { document.querySelectorAll('[data-arm-trio6]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();

